import React from 'react';
import { Calendar, Shield, Sparkles } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      icon: Calendar,
      title: 'Ride now or later',
      description: 'Book a ride instantly or schedule one up to 7 days ahead.'
    },
    {
      icon: Shield,
      title: 'Safety first',
      description: 'Share your trip details with friends and family for peace of mind.'
    },
    {
      icon: Sparkles,
      title: 'Affordable rides',
      description: 'Compare prices and choose the ride that fits your budget.'
    }
  ];

  return (
    <div className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Why choose Tekstar?
          </h2>
          <p className="text-xl text-gray-600">
            Safe, affordable, and convenient rides
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <div key={idx} className="text-center space-y-4 p-6 rounded-xl hover:bg-pink-50 transition-colors">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-pink-100 rounded-full">
                <feature.icon className="h-8 w-8 text-pink-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;
